import { Fragment, useEffect, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import SimpleBar from 'simplebar'

// No native white/light export of the wordmark exists — reuse the color PNG
// and flatten it to white via the .desktop-dark/.toggle-dark CSS filter
// (theme.scss), since this is what dark mode uses for the sidebar logo.
import desktopDark from '@/assets/brand-logos/edunet-logo-color.png'
import desktopLogo from '@/assets/brand-logos/edunet-logo-color.png'
// toggle-dark.png/toggle-logo.png were leftover blank placeholder assets
// from the Zynix template — reuse the real wordmark assets instead (see
// AppHeader.tsx for the matching fix on the mobile header logo).
const toggleDark = desktopDark
const toggleLogo = desktopLogo
import { getNavCategoriesForRole } from '@/config/navigation'
import type { UserType } from '@/constants/roles'

interface AppSidebarProps {
  role: UserType
  onNavigate?: () => void
}

export function AppSidebar({ role, onNavigate }: AppSidebarProps) {
  const categories = getNavCategoriesForRole(role)
  const scrollRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    const scrollbar = new SimpleBar(el, { autoHide: true })
    return () => scrollbar.unMount()
  }, [])

  return (
    <aside className="app-sidebar sticky" id="sidebar">
      <div className="main-sidebar-header">
        <NavLink to="/" className="header-logo">
          <img src={desktopLogo} alt="logo" className="desktop-logo" />
          <img src={toggleDark} alt="logo" className="toggle-dark" />
          <img src={desktopDark} alt="logo" className="desktop-dark" />
          <img src={toggleLogo} alt="logo" className="toggle-logo" />
        </NavLink>
      </div>

      <div className="main-sidebar" id="sidebar-scroll" ref={scrollRef}>
        <nav className="main-menu-container nav nav-pills flex-column sub-open">
          <ul className="main-menu">
            {categories.map((category) => (
              <Fragment key={category.category}>
                <li className="slide__category">
                  <span className="category-name">{category.category}</span>
                </li>
                {category.items.map((item) => (
                  <li key={item.to} className="slide">
                    <NavLink
                      to={item.to}
                      end={item.to === '/'}
                      className="side-menu__item"
                      onClick={onNavigate}
                    >
                      {item.icon}
                      <span className="side-menu__label">{item.label}</span>
                    </NavLink>
                  </li>
                ))}
              </Fragment>
            ))}
          </ul>
        </nav>
      </div>
    </aside>
  )
}
